import { render, staticRenderFns } from "./GatherWorkDetails.vue?vue&type=template&id=5e3e3d39&scoped=true"
import script from "./GatherWorkDetails.vue?vue&type=script&lang=js"
export * from "./GatherWorkDetails.vue?vue&type=script&lang=js"
import style0 from "./GatherWorkDetails.vue?vue&type=style&index=0&id=5e3e3d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e3d39",
  null
  
)

export default component.exports